<template>
  <Transition name="fade-slide" mode="out-in">
    <div
      v-show="(showHeader || y <= threshold) && isMounted"
      :style="cssVars"
      class="fixed header--fixed--main w-full z-20 group"
      :class="{ 'scrolled--header': isScrolled }"
    >
      <div>
        <slot
          v-bind="{
            showHeader,
            reachTop,
            isMounted,
            dirtyScroll,
            scrollingToTop,
          }"
          name="header"
        ></slot>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    offsetTop?: number
    threshold?: number
  }>(),
  {
    offsetTop: 0,
    threshold: 0,
  },
)

const isMounted = ref(false)

const { dirtyScroll, isScrolled, scrollingToTop, y } = useScrollValue()

const showHeader = computed(
  () =>
    ((isScrolled.value && scrollingToTop.value)
      || y.value <= props.threshold)
    && (dirtyScroll.value || isScrolled.value),
)

const reachTop = computed(() => y.value === 0)

watch(reachTop, (val) => {
  if (val === true) {
    setTimeout(() => {
      scrollingToTop.value = false
    }, 100)
  }
})

const cssVars = computed(() => ({
  '--offset-top': `${props.offsetTop}px`,
}))

onMounted(() => {
  isMounted.value = true
})
</script>

<style scoped>
.header--fixed--main {
  top: var(--offset-top);
  transition: top 0.2s ease-in-out;
}

.scrolling--to--top {
  display: block !important;
}

.scrolled--header {
  top: 0px;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition:
    opacity 0.1s,
    transform 0.2s;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-1rem);
}

.fade-slide-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0rem);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-2.5rem);
}
</style>
